export default __webpack_public_path__ + "static/media/dailyQuiz.a7262729.svg";